import { createContext } from "react";
import { type FeatureSet, featureDefaults } from "./featureDefaults";

export const FeatureFlagsContext = createContext<Partial<FeatureSet>>(featureDefaults);
